// extracted by mini-css-extract-plugin
module.exports = {"Container":"empty-state-heading_Container__X3jea"};